import BaseApi from "../../BaseApi";

export default class AssessmentModels extends BaseApi {
    construct() {}

    static getApiUrl() {
        return BaseApi.getApiVersionBasePath("v1") + "assessment-models";
    }

    static async index(filters = {}) {
        return this.get(this.getApiUrl(), filters);
    }

    static async all(filters = {}) {
        return this.index({
            params: filters,
        });
    }

    static async show(id, filters = {}) {
        return this.get(`${this.getApiUrl()}/${id}`, {
            params: filters,
        });
    }

    static async ratingOptions() {
        return this.get(`${this.getApiUrl()}/rating-options`);
    }

    static async jobTitles() {
        return this.get(`${this.getApiUrl()}/job-titles`);
    }

    static async ratingOptions() {
        return this.get(`${this.getApiUrl()}/rating-options`);
    }
}
